export default {
    category: {
        index: 'categorias',
        breadcrumb: {
            index: 'Categorias',
        },
    },

    contact: {
        index: 'contatos',
        create: 'contatos/criar',
        edit: 'contatos/editar',
        breadcrumb: {
            index: 'Contatos',
            create: 'Novo',
            edit: 'Editar',
        },
    },

    integration: {
        index: 'integracoes',
        edit: 'integracoes/editar',
        breadcrumb: {
            index: 'Integrações',
            edit: 'Editar',
        },
    },

    landingPage: {
        index: 'paginas-de-captacao',
        breadcrumb: {
            index: 'Páginas de Captação',
        },
    },

    mail: {
        index: 'email-notificacoes',
        edit: 'email-notificacoes/editar',
        breadcrumb: {
            index: 'E-mails',
            edit: 'Editar',
        },
    },
}
